import { render, staticRenderFns } from "./MemberTab.vue?vue&type=template&id=b539194c&scoped=true"
import script from "./MemberTab.vue?vue&type=script&lang=js"
export * from "./MemberTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b539194c",
  null
  
)

export default component.exports